var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconSlowMotion = function SvgIconSlowMotion(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.05 9.7898L10 7.4998V16.4998L13.05 14.2098L16 11.9998L13.05 9.7898ZM13.05 9.7898L10 7.4998V16.4998L13.05 14.2098L16 11.9998L13.05 9.7898ZM13.05 9.7898L10 7.4998V16.4998L13.05 14.2098L16 11.9998L13.05 9.7898ZM11 4.0698V2.0498C8.99005 2.2498 7.16005 3.0498 5.68005 4.2598L7.10005 5.6898C8.21005 4.8298 9.54005 4.2498 11 4.0698ZM5.69005 7.0998L4.26005 5.6798C3.05005 7.1598 2.25005 8.9898 2.05005 10.9998H4.07005C4.25005 9.5398 4.83005 8.20981 5.69005 7.0998ZM4.07005 12.9998H2.05005C2.25005 15.0098 3.05005 16.8398 4.26005 18.3198L5.69005 16.8898C4.83005 15.7898 4.25005 14.4598 4.07005 12.9998ZM5.68005 19.7398C7.16005 20.9498 9.00005 21.7498 11 21.9498V19.9298C9.54005 19.7498 8.21005 19.1698 7.10005 18.3098L5.68005 19.7398ZM22 11.9998C22 17.1598 18.08 21.4198 13.05 21.9498V19.9298C16.97 19.4098 20 16.0498 20 11.9998C20 7.9498 16.97 4.5898 13.05 4.0698V2.0498C18.08 2.5798 22 6.8398 22 11.9998Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSlowMotion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_slow_motion.1c2008e7.svg";
export { ForwardRef as ReactComponent };